import { getErrorText } from '../../../../../common/api/errors'
import {
  LOCAL_ADAPTER_ERROR_FALLBACK,
  LOCAL_ADAPTER_ERROR_LABEL,
  OVERPAYMENT_CREATE_ERROR_FALLBACK,
  OVERPAYMENT_CREATE_ERROR_LABEL,
} from './consts'

/** Text of a refused overpayment creation: the label of its code, else the backend sentence or field error. */
export const overpaymentCreateErrorText = (error: unknown): string =>
  getErrorText(error, OVERPAYMENT_CREATE_ERROR_FALLBACK, { labels: OVERPAYMENT_CREATE_ERROR_LABEL })

/** Text of a refused payment of an overpayment through the local adapter, read the same way. */
export const localAdapterErrorText = (error: unknown): string =>
  getErrorText(error, LOCAL_ADAPTER_ERROR_FALLBACK, { labels: LOCAL_ADAPTER_ERROR_LABEL })
